var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeSimpleOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.409 9V18.75C3.409 18.9489 3.49486 19.1397 3.64769 19.2803C3.80053 19.421 4.00781 19.5 4.22395 19.5H22.153C22.3691 19.5 22.5764 19.421 22.7292 19.2803C22.8821 19.1397 22.9679 18.9489 22.9679 18.75V9L13.1885 3L3.409 9Z",
    stroke: "#B27D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9679 9L14.9666 14.25H11.4103L3.409 9",
    stroke: "#B27D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSimpleOpen);
export default __webpack_public_path__ + "static/media/EnvelopeSimpleOpen.66bd6cc31deae41a767e7d8c3ed7e04d.svg";
export { ForwardRef as ReactComponent };